
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/cookies",
      function () {
        return require("private-next-pages/help/cookies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/cookies"])
      });
    }
  